import { Stack } from "@mui/material";
import { FileItem } from "./FileItem";
import { useScrollWrapper } from "../../../hooks";

export const FileList = ({
  files,
  isDisabled,
  removeFileHandler,
  changeFileHandler,
  maxHeight = "232px",
  filesWithError,
  mimeTypes,
  acceptedExtensions,
}: {
  files: File[];
  filesWithError?: string[];
  isDisabled: boolean;
  removeFileHandler: (name: string) => void;
  changeFileHandler?: (fileName: string, file: File) => void;
  maxHeight?: string;
  mimeTypes?: string[];
  acceptedExtensions: string[];
}) => {
  const { scrollRef } = useScrollWrapper({ trigger: files });

  if (files.length === 0) return null;

  return (
    <Stack
      ref={scrollRef}
      sx={{
        gap: "8px",
        maxHeight,
        overflowY: "auto",
        "&::-webkit-scrollbar": {
          width: "8px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#aaa",
          borderRadius: "4px",
        },
        "&::-webkit-scrollbar-track": {
          width: "12px",
          backgroundColor: "transparent",
        },
      }}
    >
      {files.map((file) => (
        <FileItem
          isError={filesWithError?.includes(file.name)}
          isDisabled={isDisabled}
          key={file.name}
          file={file}
          removeFileHandler={removeFileHandler}
          changeFileHandler={changeFileHandler}
          mimeTypes={mimeTypes}
          acceptedExtensions={acceptedExtensions}
        />
      ))}
    </Stack>
  );
};
